<script>

  import ColorPicker from '../../Common/ColorPicker.svelte';
  import Checkbox from '../../Common/Checkbox.svelte';
  import { ignore } from '../../Common/tools';
  import { External, M } from '../../external';

  export let styling, onChange = ignore;

  let notifyChanged = () => {
    onChange(styling);
  };

</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> brush </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.ICON_STYLING}</h4>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.fg.color}
      bind:colorClass={styling.fg.colorClass}
      onChange={notifyChanged}
      label={M.ICON_COLOR}
    />
  </div>

  <div class="col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={styling.bg.color}
      bind:colorClass={styling.bg.colorClass}
      onChange={notifyChanged}
      label={M.ICON_BACKGROUND_COLOR}
    />
  </div>

  <div class="col20 f-left">
    <Checkbox bind:data={styling.hasBorder} onChange={notifyChanged} label={M.ADD_ICON_BORDER} />
  </div>

  {#if styling.hasBorder}
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker
        bind:color={styling.border.color}
        bind:colorClass={styling.border.colorClass}
        onChange={notifyChanged}
        label={M.BORDER_COLOR}
      />
    </div>
  {/if}
</div>

